import NProgress from "nprogress";
import 'nprogress/nprogress.css'

NProgress.configure({
    easing: 'ease', // 动画方式
    speed: 1000, // 递增进度条的速度
    showSpinner: true, // 是否显示加载ico
    trickleSpeed: 500, // 自动递增间隔
    minimum: 0.3, // 更改启动时使用的最小百分比
    parent: '#app', //指定进度条的父容器
});

window.parent.progressLoadingCount = 0;
// 打开进度条
export const nprogressStart = () => {
    if(window.parent.progressLoadingCount === 0){
        window.parent.nprogressStart()
    }
    window.parent.progressLoadingCount++;
}

// 关闭进度条
export const nprogressClose = () => {
    window.parent.progressLoadingCount--;
    if(window.parent.progressLoadingCount < 0){
        window.parent.progressLoadingCount = 0;
    }
    let progressLoadingClose = setTimeout(function(){
        if(window.parent.progressLoadingCount === 0){
            window.parent.nprogressClose()
        }else {
            clearTimeout(progressLoadingClose)
        }
    },200)

}

window["nprogressStart"] = ()=>{
    NProgress.inc();
}

window["nprogressClose"] = ()=>{
    NProgress.done(true);
}

window["progressLoadingCount"] = 0;